import React from 'react'
import { connect } from 'react-redux'
import { batchUpdateCalculatorAction } from 'actions/calculatorActions'
import { updateCameraAction } from 'actions/cameraActions'
import getCurrentCamera from 'helpers/cameras/getCurrentCamera'
import determinePpfNightMode from 'helpers/cameras/determinePpfNightMode'
import equals from 'ramda/src/equals'
import injectSheet from 'react-jss'
import style from './style'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const nightModeOptions = { conventional: 'Dark No IR', superLowLight: 'Super Low Light', infrared: 'Dark With IR' }

const mapStateToProps = ({ ui: { isImperial }, cameras }) => {
  const camera = getCurrentCamera(cameras)
  return {
    camera,
    isImperial
  }
}

class NightModeSelector extends React.Component {
  state = {
    dropdownOpen: false,
    selectable: determinePpfNightMode(this.props.camera, this.props.isImperial).selectable
  }

  toggleDropdown = _ => this.setState({ dropdownOpen: !this.state.dropdownOpen })

  componentWillReceiveProps({ camera, isImperial }) {
    const { userSelectedPpfNightMode } = camera
    const { mode, selectable } = determinePpfNightMode(camera, isImperial)
    const cameraModelChanged = !equals(camera.model, this.props.camera.model)

    if (cameraModelChanged && userSelectedPpfNightMode) this.setState({ userSelected: false })
    if (mode !== camera.ppfNightMode && !(userSelectedPpfNightMode && selectable.includes(mode))) this.props.updateCameraAction('ppfNightMode', mode, camera.id)
    if (!equals(selectable, this.state.selectable)) this.setState({ selectable })
  }

  userSelectedMode = option => {
    this.props.batchUpdateCalculatorAction(
      { ppfNightMode: option, userSelectedPpfNightMode: true },
      ['ppfNightMode', 'userSelectedPpfNightMode'],
      this.props.camera.id,
      false
    )
  }

  render() {
    const { state: { dropdownOpen, selectable }, props: { camera: { ppfNightMode }, onMobile, classes },
      userSelectedMode, toggleDropdown } = this
    return (
      <div className={onMobile ? classes.mobileContainer : classes.container} onClick={toggleDropdown}>
        {nightModeOptions[ppfNightMode]}
        {
          dropdownOpen
          ? <FontAwesomeIcon icon='caret-up' className={classes.caret} />
          : <FontAwesomeIcon icon='caret-down' className={classes.caret} />
        }
        <div className={dropdownOpen ? classes.openDropdown : classes.closedDropdown}>
          {
            selectable.map((option, i) => (
              <div
                key={i}
                onClick={userSelectedMode.bind(this, option)}
                className={classes.option}>
                {nightModeOptions[option]}
              </div>
            ))
          }
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps, { updateCameraAction, batchUpdateCalculatorAction })(injectSheet(style)(NightModeSelector))



// WEBPACK FOOTER //
// ./src/components/PpfPreview/NightModeSelector/index.js